import { deviceFieldKeysMap as commonDeviceFieldKeysMap } from '~common-maps/deviceFieldKeys.map';
import { deviceFieldKeysMap } from '~/maps/deviceFieldKeys.map';
import { deviceTypesMap } from '~common-maps/deviceTypes.map';
import { userFieldKeysMap } from '~/maps/userFieldKeys.map';
import { commonHomeFieldKeysMap, securityHomeFieldKeysMap, energyHomeFieldKeysMap } from '~/maps/homeFieldKeys.map';
import { commonSupportFieldKeysMap } from '~/maps/commonSupportFieldKeys.map';
import { deviceBehaviorFieldKeysMap } from '~/maps/deviceBehaviorFieldKeys.map';
import { deviceOffsetFieldKeysMap } from '~/maps/deviceOffsetFieldKeys.map';
import { humanReadableValueFromMap } from '~common-helpers/index';
import { packagingKeysMap } from '~/maps/packagingKeys.map';
import { ergonomicKeysMap } from '~/maps/ergonomicKeys.map';
import { subtypeKeysMap } from '~/maps/subtypeKeys.map';
import { relaySubtypeKeysMap } from '~/maps/relaySubtypeKeys.map';
import { deviceTimelineFieldKeys } from '~/maps/deviceTimelineFieldKeys.map';
import { humanReadableMethodsLog } from '~/maps/humanReadableMethodsLog.map';
import { appNameKeysMap } from '~/maps/appNameKeys.map';
import { consentsMarketingsFieldKeysMap } from '~/maps/consentsMarketingsFieldKeys.map';

export function humanReadableField(value: string) {
    const mergedMap = new Map([
        ...commonDeviceFieldKeysMap,
        ...deviceFieldKeysMap,
        ...deviceTypesMap,
        ...userFieldKeysMap,
        ...commonHomeFieldKeysMap,
        ...securityHomeFieldKeysMap,
        ...energyHomeFieldKeysMap,
        ...commonSupportFieldKeysMap,
        ...deviceBehaviorFieldKeysMap,
        ...packagingKeysMap,
        ...ergonomicKeysMap,
        ...deviceOffsetFieldKeysMap,
        ...relaySubtypeKeysMap,
        ...subtypeKeysMap,
        ...deviceTimelineFieldKeys,
        ...humanReadableMethodsLog,
        ...appNameKeysMap,
        ...consentsMarketingsFieldKeysMap,
    ]);
    return humanReadableValueFromMap(mergedMap, value) || 'N/A';
}



